import { Loader2, PackageOpen, TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function CenterSpinner({ className }) {
  return (
    <div className={cn("flex items-center justify-center py-16", className)} data-testid="loading-spinner">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}

export function CardSkeletons({ count = 6, className }) {
  return (
    <div className={cn("grid gap-4 sm:grid-cols-2 lg:grid-cols-3", className)}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl border bg-card p-4">
          <Skeleton className="mb-3 h-32 w-full rounded-xl" />
          <Skeleton className="mb-2 h-4 w-2/3" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ icon: Icon = PackageOpen, title, description, action, testId }) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-2xl border border-dashed bg-card/60 px-6 py-16 text-center"
      data-testid={testId || "empty-state"}
    >
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
        <Icon className="h-7 w-7 text-muted-foreground" />
      </div>
      <h3 className="font-display text-lg">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErrorState({ onRetry, message = "Something went wrong." }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border bg-card px-6 py-14 text-center" data-testid="error-state">
      <TriangleAlert className="mb-3 h-8 w-8 text-destructive" />
      <p className="text-sm text-muted-foreground">{message}</p>
      {onRetry && (
        <Button variant="outline" className="mt-4 rounded-full" onClick={onRetry} data-testid="retry-button">
          Try again
        </Button>
      )}
    </div>
  );
}
